var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 226,
    viewBox: "0 0 225 226",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1709_36258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.773 119.207V215.504C224.773 220.898 220.402 225.269 215.007 225.269H9.99292C4.59871 225.269 0.227539 220.898 0.227539 215.504V196.658",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.995 92.8863L216.768 92.8588C221.19 92.8588 224.773 89.2695 224.773 84.8467V10.4919C224.773 5.09774 220.402 0.726562 215.007 0.726562H9.99292C4.59871 0.726562 0.227539 5.09774 0.227539 10.4919V162.315C0.227539 166.738 3.81335 170.327 8.23963 170.327H79.4391",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.292 176.004C67.0865 173.696 38.4448 144.173 38.4448 108.07C38.4448 71.9673 69.5563 39.9844 107.912 39.9844C144.193 39.9844 173.972 67.2413 177.069 102.035",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.554 109.763C164.221 104.035 156.777 97.3452 155.089 92.4608C154.187 89.8843 159.557 90.7695 160.693 91.1553C164.61 92.5021 164.338 100.845 170.176 96.7286C171.785 95.5747 173.077 94.3829 174.995 93.7284",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.174 54.3258C143.219 55.6726 135.654 50.175 130.76 55.4039C129.192 57.0952 128.252 62.6685 125.159 62.1312C124.101 61.9383 123.082 61.363 121.986 61.5938C121.28 61.7075 120.653 62.2104 120.144 62.7099C117.598 65.0556 115.679 68.0938 114.463 71.2834C114.188 71.9379 113.992 72.6303 114.071 73.3226C114.267 74.6281 115.679 75.5134 117.088 75.6305C118.459 75.7442 119.792 75.286 121.084 74.7831C124.415 73.5534 128.331 70.7461 132.017 70.939C136.836 71.2077 143.143 75.131 147.494 77.2047C148.827 77.8212 156.742 85.3167 151.334 85.3167C147.494 85.3167 141.658 86.3948 138.286 84.7001C135.544 83.3154 134.328 80.7009 131.39 79.7778C129.547 79.2025 127.277 79.2025 125.317 78.9304C125.042 78.8925 124.845 78.9304 124.611 79.0062C120.653 80.6596 115.796 81.9651 112.503 84.6209C108.349 88.0034 106.899 92.2334 107.526 97.3451C107.877 100.304 107.957 103.535 109.173 106.263C111.325 111.223 117.712 111.03 122.338 111.03C124.453 111.03 130.095 111.606 131.428 113.414C133.037 115.529 131.507 118.488 132.448 120.872",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4678 95.8835C39.7399 95.9972 39.9776 96.1522 40.1739 96.3451C42.995 99.6898 46.2467 102.842 49.7705 105.763C55.5299 110.606 53.1806 111.184 51.7305 116.644C50.3216 122.028 54.7479 126.678 59.2534 130.254C61.0963 131.714 63.0563 133.212 64.0724 135.097C65.1299 136.943 65.2091 139.058 65.4847 141.056C66.6593 149.784 73.0455 159.164 83.7823 160.7C85.3117 158.892 80.1379 157.548 80.1 155.358C80.0587 153.511 83.2346 153.088 84.9982 151.937C87.3474 150.401 87.0374 147.476 88.212 145.21C89.3074 143.133 91.7014 141.71 93.5408 139.981C97.9292 135.944 99.2244 130.409 100.358 125.142C100.516 124.336 100.709 123.413 100.316 122.644C99.9649 121.952 99.2209 121.453 98.4355 121.029C91.7772 117.147 83.0762 115.762 77.2789 111.071C74.1444 108.532 71.6367 104.767 67.4068 103.189C61.0584 100.844 53.7318 101.653 50.518 95.9249C48.6786 92.656 48.0103 86.3524 53.6526 85.3534C60.9 84.0479 66.1116 80.2417 70.655 75.7431C70.6929 75.7052 70.7721 75.6294 70.8513 75.5881C75.1605 72.6292 79.2768 69.6289 84.0544 67.2074C87.778 65.2853 91.0676 63.9006 89.6588 59.7878C88.4807 56.3294 87.778 56.7118 83.6617 57.6728C77.3547 59.1333 71.7504 60.2493 65.1678 59.0575C64.8922 58.9817 60.3075 57.442 61.9953 57.9036",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.14 173.735C117.398 164.587 116.809 155.434 121.118 146.554C126.878 134.753 136.633 127.523 149.367 124.065C156.38 122.18 163.514 120.682 170.527 118.798C175.463 117.492 179.655 114.916 182.359 110.455C183.575 108.457 185.26 107.765 186.083 110.455C190.041 123.72 193.685 137.137 191.098 151.129C186.317 177.387 163.159 200.954 126.096 180.001",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.937 191.268C106.937 191.268 115.989 170.931 140.439 164.162C164.889 157.397 169.239 139.826 169.239 139.826",
    stroke: "#7F9398",
    strokeWidth: 1.32,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1709_36258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldIcon);
export default __webpack_public_path__ + "static/media/world-icon.17581c63.svg";
export { ForwardRef as ReactComponent };